"use client"

import { useState } from "react"
import { Info, ChevronDown, ChevronRight } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { useTranslation } from "@/hooks/use-translation"
import type { TranslationKey } from "@/lib/translations"

export function EntityHelpCard() {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Card className="bg-blue-50 border-blue-200">
      <CardHeader className="pb-3">
        <Button
          variant="ghost"
          className="p-0 h-auto text-blue-900 hover:text-blue-700 hover:bg-transparent w-full justify-start"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <CardTitle className="flex items-center space-x-2 text-sm font-medium w-full">
            <Info className="h-4 w-4" />
            <span>{t("entityHelp.card.title")}</span>
            {isExpanded ? (
              <ChevronDown className="h-4 w-4 ml-auto" />
            ) : (
              <ChevronRight className="h-4 w-4 ml-auto" />
            )}
          </CardTitle>
        </Button>
      </CardHeader>
      {isExpanded && (
        <CardContent className="space-y-3 text-sm pt-0">
          <div>
            <p className="font-medium text-blue-900 mb-1">{t("entityHelp.entityType.title")}</p>
            <p className="text-blue-800">{t("entityHelp.entityType.body")}</p>
            <div className="flex flex-wrap gap-1 mt-1">
              <Badge variant="outline" className="text-xs">ClientContact</Badge>
              <Badge variant="outline" className="text-xs">JobOrder</Badge>
              <Badge variant="outline" className="text-xs">Placement</Badge>
              <Badge variant="outline" className="text-xs">CorporateUser</Badge>
            </div>
          </div>
          <div>
            <p className="font-medium text-blue-900 mb-1">{t("entityHelp.entityName.title")}</p>
            <p className="text-blue-800">
              {t("entityHelp.entityName.body")}
            </p>
            <div className="flex flex-wrap gap-1 mt-1">
              <Badge variant="outline" className="text-xs">TimesheetApprover</Badge>
              <Badge variant="outline" className="text-xs">ClientManager</Badge>
              <Badge variant="outline" className="text-xs">Recruiter</Badge>
            </div>
          </div>
          <div>
            <p className="font-medium text-blue-900 mb-1">{t("entityHelp.referenceId.title")}</p>
            <p className="text-blue-800">
              <span className="font-semibold">{t("entityHelp.referenceId.required")}</span> {t("entityHelp.referenceId.format")}
            </p>
            <div className="flex flex-wrap gap-1 mt-1">
              <Badge variant="outline" className="text-xs">Placement.clientContact.id</Badge>
              <Badge variant="outline" className="text-xs">TimesheetApprover.client.id</Badge>
            </div>
          </div>
          <div className="bg-blue-100 p-2 rounded text-xs text-blue-900">
            <p className="font-medium mb-1">{t("entityHelp.important.title")}</p>
            <p>{t("entityHelp.important.body")}</p>
          </div>
        </CardContent>
      )}
    </Card>
  )
} 